<template>
  <div class="content work_wrapper">
    <v-row class="search_box">
      <v-col>
        <searchBar></searchBar>
      </v-col>
    </v-row>
    <div class="report_center_wrapper">
      <div class="flex_style betw mart24 marb24">
        <div class="md_title">{{ title }}-报告分析</div>
        <div>
          <!-- <v-btn @click="goDownload">下载</v-btn>
<v-btn class="marl10"
       @click="goEmail">邮件</v-btn> -->
          <!-- <v-btn class="icons excel"
       @click="goDownload">
  <span class="icons excel activepic"></span>
  下载最新的word</v-btn>
<v-btn @click="goDownload">下载最新的pdf</v-btn>
<v-btn @click="goDownload">历史下载记录</v-btn> -->
          <!--下载的文件格式-->
          <!---->
          <div class="line_item">
            <div class="flex_style leftworder">
              <v-btn @click="goDownload"
                     style="margin-left:20px;">
                                <span :class="{'icons word':true}"
                                      @click="formatKey=0"></span>
                下载最新woder
              </v-btn>
              <v-btn @click="goDownload"
                     style="margin-left:10px;">
                                <span :class="{'icons ppt':true}"
                                      @click="formatKey=1"></span>
                下载最新的pdf
              </v-btn>
              <v-btn @click="goDownload"
                     style="margin-left:10px;">
                <span @click="formatKey=2"></span>
                历史下载记录
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="bread_route margbsm hand"
           @click="goBack">返回分析报告主页
      </div>
      <div class="center_content">
        <v-row>
          <v-col sm="4"
                 md="2">
            <div class="left_side1">
              <div class="title1">分析主页</div>
              <div class="type_wrapper"
                   v-for="(item,index) in totalFilter"
                   :key="index">
                <div class="tit">{{ item.name }}</div>
                <div :class="{'line':true,'active': activeValue == item1.value}"
                     v-for="(item1,index1) in item.data"
                     :key="index1"
                     @click="getKeyList(item.name,item1.name)">
                  {{ item1.name }}
                </div>
              </div>
              <!-- <div class="type_wrapper">
  <div class="tit">竞争对手定位</div>
  <div class="line"></div>
</div> -->
            </div>
          </v-col>
          <v-col sm="8"
                 md="10">
            <div class="right_side1">
              <div class="flex_style left topName bread_route">
                <div class="flex_style left">
                  <span>{{ title1 }}</span>
                  <v-icon>mdi-chevron-right</v-icon>
                  <span>{{ activeName }}</span>
                </div>
              </div>
              <v-tabs show-arrows
                      v-model="activeKey"
                      @change="handleChange">
                <v-tab v-for="(item,index) in tabsList"
                       :key="index">{{ item.name }}
                </v-tab>
                <!--弹窗-->
                <v-row justify="center">
                  <v-dialog v-model="dialog"
                            persistent
                            max-width="880px"
                            max-height="494px">
                    <template v-slot:activator="{ on, attrs }">
                      <div>
                          <span class="bread_route margbsm hand"
                                v-bind="attrs"
                                v-on="on">
                              <v-icon>mdi-pencil-box-outline</v-icon>
                              编辑报告单
                            </span>
                      </div>
                    </template>
                    <v-card>
                      <v-card-title>
                        <v-container fill-height>
                          <v-row justify="center"
                                 align="center">
                                                        <span class="text-h6  test"
                                                              center
                                                              style="margin-top:20px;">新能源行业锂电池专分析报告
                                                            <v-icon>mdi-pencil-box-outline</v-icon>
                                                        </span>

                          </v-row>
                          <span>
                                                        <v-icon @click="dialog=f
                                  alse
                                  ">
                                                            mdi-window-close
                                                        </v-icon>
                                                    </span>
                        </v-container>

                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
<span class="text-h6 test" style="margin-top:20px;">副标题</span>
                              <div class="descInfo_wrapper"
                                   v-if="descInfo.desc">
                                <div class="desc_line"
                                     v-if="!editVisible">
                                  <div class="icon"
                                       @click="editVisible=true">
                                    <div>{{ descInfo.desc }}</div>
                                    <v-icon>mdi-pencil-box-outline</v-icon>
                                  </div>
                                </div>
                                <div v-if="editVisible
                                  ">
                                  <div class="desc_line
                                  ">
                                    <v-textarea outlined
                                                name="input-7-4
                                  "
                                                label="
                                  "
                                                v-model="descInfo.desc
                                  "
                                                hide-details></v-textarea>
                                  </div>
                                  <div class="flex_style
                                  right2
                                  ">
                                    <v-btn @click="editVisible=false
                                  ">取消
                                    </v-btn>
                                    <v-btn class="marl10
                                  "
                                           color="primary
                                  "
                                           @click="saveDesc(descInfo)
                                  ">保存
                                    </v-btn>
                                  </div>
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="12 ">
                                                            <span class="text-h6 test">背景简介</span>
                              <div class="descInfo_wrapper " v-if="descInfo.desc">
                                <div class="desc_line" v-if="!editVisible2">
                                  <div class="icon "
                                       @click="editVisible2=true">
                                    <div>{{ descInfo.desc }}</div>
                                    <v-icon>mdi-pencil-box-outline</v-icon>
                                  </div>
                                </div>
                                <div v-if="editVisible2">
                                  <div class="desc_line">
                                    <v-textarea outlined name="input-7-4 " label="  " v-model="descInfo.desc" hide-details></v-textarea>
                                  </div>
                                  <div class="flex_style right2 ">
                                    <v-btn @click="editVisible2=false">取消
                                    </v-btn>
                                    <v-btn class="marl10" color="primary" @click="saveDesc(descInfo)">保存</v-btn>
                                  </div>
                                </div>
                              </div>

                              <!-- <v-text-field label="背景简介
    "
              required>
  <v-textarea>
    文本的内容
  </v-textarea>
</v-text-field> -->
                            </v-col>
                            <v-col cols="12">
                              <span class="text-h6 test">摘要概括</span>
                              <div class="descInfo_wrapper " v-if="descInfo.desc">
                                <div class="desc_line " v-if="!editVisible3">
                                  <div class="icon "
                                       @click="editVisible3=true">
                                    <div>{{ descInfo.desc }}</div>
                                    <v-icon>mdi-pencil-box-outline</v-icon>
                                  </div>
                                </div>
                                <div v-if="editVisible3">
                                  <div class="desc_line">
                                    <v-textarea outlined name="input-7-4" label="" v-model="descInfo.desc" hide-details></v-textarea>
                                  </div>
                                  <div class="flex_styleright2">
                                    <v-btn @click="editVisible3=false">取消</v-btn>
                                    <v-btn class="marl10" color="primary" @click="saveDesc(descInfo)">保存</v-btn>
                                  </div>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </v-tabs>
              <!--弹窗-->

              <!---->

              <v-tabs-items v-model="activeKey">
               <v-tab-item v-for="(item,index) in tabsList " :key="index ">
                  <div class="content_list">
                    <v-overlay :absolute="absolute" :value="loading"  :opacity="opacity" color="#fff">
                      <div class="loading_btn">
                        <v-btn class="ma-2 " :loading="loading1" color="primary"></v-btn>
                      </div>
                    </v-overlay>
                    <div class="list_box" v-if="specialList.indexOf(value)<0">
                      <div :class="['chart_box',item.value]" :ref="item.value"></div>
                    </div>
                    <div v-if="specialList.indexOf(value)>-1">
                      <div>
                        <div v-for="(item1,index1) in valueList"
                             :key="index1">
                          <div :class="['chart_box',item1]"></div>
                          <div class="descInfo_wrapper"
                               v-if="descInfoList[index1]">
                            <div class="desc_line"
                                 v-if="!editVisible">
                              <div>{{ descInfoList[index1].desc }}</div>
                              <div class="icon"
                                   @click="editVisible = true">
                                <v-icon>mdi-pencil-box-outline</v-icon>
                              </div>
                            </div>
                            <div v-if="editVisible">
                              <div class="desc_line">
                                <v-textarea outlined
                                            name="input-7-4"
                                            label=""
                                            v-model="descInfoList[index1].desc"
                                            hide-details></v-textarea>
                              </div>
                              <div class="flex_style right">
                                <v-btn @click="editVisible = false">取消</v-btn>
                                <v-btn class="marl10"
                                       color="primary"
                                       @click="saveDesc(descInfoList[index1])">保存
                                </v-btn>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="dataList.length>0">
                      <div class="comp_list1 mart24 margbsm">
                        <div class="line_item">
                          <span>序号</span>
                          <span>公开(公告)号</span>
                          <span>核心技术</span>
                          <span>申请人</span>
                          <span>被引频次</span>
                          <span>申请时间</span>
                          <span>失效时间</span>
                        </div>
                        <div class="line_item"
                             v-for="(item,index) in dataList"
                             :key="index">
                          <span>{{ index + 1 }}</span>
                          <span :title="item.documentNumber">{{ item.documentNumber }}</span>
                          <span :title="item.mainIp">{{ item.mainIpc }}</span>
                          <span :title="item.applicant">{{ item.applicant }}</span>
                          <span :title="item.citedCount">{{ item.citedCount }}</span>
                          <span :title="item.applicationDate">{{ item.applicationDate }}</span>
                          <span :title="item.expiredDate">{{ item.expiredDate }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="dataList1.length>0">
                      <div class="comp_list1 mart24 margbsm">
                        <div class="line_item">
                          <span>名称</span>
                          <span>专利数</span>
                          <span>活动年限</span>
                          <span>发明人数</span>
                          <span>平均专利年龄</span>
                          <span>引用次数</span>
                          <span>自我引证次数</span>
                          <span>被引证次数</span>
                          <span>总引证次数</span>
                          <span>引证率</span>
                          <span>技术独立性</span>
                        </div>
                        <div class="line_item"
                             v-for="(item,index) in dataList1"
                             :key="index">
                          <span :title="item.name">{{ item.name }}</span>
                          <span :title="item.num">{{ item.num }}</span>
                          <span :title="item.yearNum">{{ item.yearNum }}</span>
                          <span :title="item.inventorNum">{{ item.inventorNum }}</span>
                          <span :title="item.avgAge">{{ item.avgAge }}</span>
                          <span :title="item.citingCount">{{ item.citingCount }}</span>
                          <span :title="item.selfCited">{{ item.selfCited }}</span>
                          <span :title="item.otherCited">{{ item.otherCited }}</span>
                          <span :title="item.citedCount">{{ item.citedCount }}</span>
                          <span :title="item.avgCited">{{ item.avgCited }}</span>
                          <span :title="item.rate">{{ item.rate }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="dataList2">
                      <div class="comp_list1 mart24 margbsm">
                        <div class="line_item">
                          <span>关联度</span>
                          <span v-for="(item1,index1) in dataList2.titleKey"
                                :key="index1">{{ item1 }}</span>
                        </div>
                        <div class="line_item"
                             v-for="(item2,key2,index2) in dataList2.valueMap"
                             :key="index2">
                          <span>{{ key2 }}</span>
                          <span v-for="(item3,index3) in item2"
                                :key="index3"
                                :title="item3">{{ item3 }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="dataList3.length>0">
                      <div class="comp_list1 mart24 margbsm">
                        <div class="line_item">
                          <span>申请人</span>
                          <span>专利数量</span>
                          <span> 引用专利数量</span>
                          <span>平均引用</span>
                          <span>被引频次</span>
                          <span>平均被引频次</span>
                        </div>
                        <div class="line_item"
                             v-for="(item,index) in dataList3"
                             :key="index">
                          <span :title="item.name">{{ item.name }}</span>
                          <span :title="item.num">{{ item.num }}</span>
                          <span :title="item.citingCount">{{ item.citingCount }}</span>
                          <span :title="item.citingAvg">{{ item.citingAvg }}</span>
                          <span :title="item.citedCount">{{ item.citedCount }}</span>
                          <span :title="item.citedAvg">{{ item.citedAvg }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="dataList4.length>0">
                      <div class="comp_list1 mart24 margbsm">
                        <div class="line_item">
                          <span>IPC分类号</span>
                          <span>专利申请量</span>
                          <span>占申请总量</span>
                          <span>申请涉及到的IPC大类</span>
                          <span>申请涉及到的IPC小类</span>
                          <span>申请涉及到的IPC分类号</span>
                        </div>
                        <div class="line_item"
                             v-for="(item,index) in dataList4"
                             :key="index">
                          <span :title="item.iprc1">{{ item.ipc1 }}</span>
                          <span :title="item.number">{{ item.number }}</span>
                          <span :title="item.rateString">{{ item.rateString }}</span>
                          <span :title="item.ipcDLNumber">{{ item.ipcDLNumber }}</span>
                          <span :title="item.ipcXLNumber">{{ item.ipcXLNumber }}</span>
                          <span :title="item.ipcCNumber">{{ item.ipcCNumber }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="descInfo_wrapper"
                         v-if="descInfo.desc">
                      <div class="desc_line"
                           v-if="!editVisible">
                        <div>{{ descInfo.desc }}</div>
                        <div class="icon"
                             @click="editVisible = true">
                          <v-icon>mdi-pencil-box-outline</v-icon>
                        </div>
                      </div>
                      <div v-if="editVisible">
                        <div class="desc_line">
                          <v-textarea outlined
                                      name="input-7-4"
                                      label=""
                                      v-model="descInfo.desc"
                                      hide-details></v-textarea>
                        </div>
                        <div class="flex_style right">
                          <v-btn @click="editVisible = false">取消</v-btn>
                          <v-btn class="marl10"
                                 color="primary"
                                 @click="saveDesc(descInfo)">保存
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
              <!-- </v-tabs> -->
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import searchBar from '@/components/widgets/searchBar.vue'
import {mapActions} from 'vuex'
import echarts from 'echarts'

export default {
  data() {
    return {
      dialog: false,
      editVisible: false,
      editVisible2: false,
      editVisible3: false,
      absolute: true,
      loading: false,
      loading1: true,
      opacity: 1,
      selectKeys: [],
      data: [
        {
          id: '1',
          documentNumber: 'sss',
          title: 'iiii',
          imagePath: '/pppp'
        },
        {
          id: '2',
          documentNumber: '33fedd',
          title: 'iwwwwiii',
          imagePath: '/pppp'
        }
      ],
      totalFilter: [
        {
          name: '核心图表分析',
          data: [
            {
              name: '专利概况',
              value: 'core1',
              list: [
                {
                  name: '专利趋势',
                  value: 'coreTrend',
                  path: '/core/trend',
                  descPath: '/opinion/core_trend_10'
                  //专利趋势的接口数据
                },
                {
                  name: '专利授权分析',
                  value: 'coreGrant',
                  path: '/core/grant',
                  descPath: '/opinion/core_trend_20'
                },
                {
                  name: '专利维持分析',
                  value: 'coreHold',
                  path: '/core/hold',
                  descPath: '/opinion/core_trend_30'
                }
              ]
            },
            {
              name: '地域分析',
              value: 'core2',
              list: [
                {
                  name: '全球地域分析',
                  value: 'coreArea',
                  path: '/core/area',
                  descPath: '/opinion/core_area_10'
                },
                {
                  name: '地域趋势分布',
                  value: 'coreAreaTrend',
                  path: '/core/area_trend',
                  descPath: '/opinion/core_area_30'
                }
              ]
            },
            {
              name: '技术分析',
              value: 'core3',
              list: [
                {
                  name: '技术分类分析',
                  value: 'coreTech',
                  path: '/core/tech',
                  descPath: [
                    '/opinion/core_tech_14',
                    '/opinion/core_tech_13',
                    '/opinion/core_tech_16',
                    '/opinion/core_tech_10',
                    '/opinion/core_tech_15',
                    '/opinion/core_tech_12',
                    '/opinion/core_tech_11'
                  ]
                },
                {
                  name: '技术生命周期图',
                  value: 'coreTechActivity',
                  path: '/core/tech_activity',
                  descPath: '/opinion/core_tech_20'
                },
                {
                  name: '专利组合分析',
                  value: 'coreTechGroup',
                  path: '/core/tech_group',
                  descPath: '/opinion/core_tech_30'
                },
                {
                  name: '技术成长率',
                  value: 'coreTechGrowth',
                  path: '/core/tech_growth',
                  descPath: '/opinion/core_tech_40'
                }
              ]
            },
            {
              name: '发明人分析',
              value: 'core4',
              list: [
                {
                  name: '竞争公司发明人比较',
                  value: 'coreInventor',
                  path: '/core/inventor',
                  descPath: '/opinion/core_inventor_10'
                },
                {
                  name: '核心发明人',
                  value: 'coreInventorCore',
                  path: '/core/inventor_core',
                  descPath: [
                    '/opinion/core_inventor_20',
                    '/opinion/core_inventor_21'
                  ]
                },
                {
                  name: '研发人员投入分析',
                  value: 'coreInventorAnalysis',
                  path: '/core/inventor_input_analysis',
                  descPath: '/opinion/core_inventor_30'
                }
              ]
            },
            {
              name: '申请人分析',
              value: 'core5',
              list: [
                {
                  name: '历年申请人活跃趋势',
                  value: 'coreApplicant',
                  path: '/core/applicant',
                  descPath: '/opinion/core_applicant_10'
                },
                {
                  name: '基于专利活跃度的机构情况分析',
                  value: 'coreApplicantAgency',
                  path: '/core/applicant_agency',
                  descPath: '/opinion/core_applicant_20'
                },
                {
                  name: '核心申请人',
                  value: 'coreApplicantCore',
                  path: '/core/applicant_core',
                  descPath: '/opinion/core_applicant_31'
                },
                {
                  name: '技术领域分布',
                  value: 'coreApplicantCompany5',
                  path: '/core/applicant_company_ipc_5',
                  descPath: '/opinion/core_applicant_40'
                },
                {
                  name: '技术关联情况分析',
                  value: 'coreApplicantIpcCited',
                  path: '/core/applicant_ipc_cited',
                  descPath: '/opinion/core_applicant_50'
                },
                {
                  name: '中国省市分布',
                  value: 'coreAreaCn',
                  path: '/core/area_cn',
                  descPath: ['/opinion/core_area_20']
                }
              ]
            },
            {
              name: '专利权人分析',
              value: 'core6',
              list: [
                {
                  name: '历年专利权人活跃趋势',
                  value: 'coreAssignee',
                  path: '/core/assignee',
                  descPath: '/opinion/core_assignee_10'
                },
                {
                  name: '核心专利权人',
                  value: 'coreAssigneeCore',
                  path: '/core/assignee_core',
                  descPath: '/opinion/core_assignee_21'
                }
              ]
            },
            {
              name: '失效专利分析',
              value: 'core7',
              list: [
                {
                  name: '历年失效专利分析',
                  value: 'coreInvalid',
                  path: '/core/invalid',
                  descPath: '/opinion/core_invalid_10'
                },
                {
                  name: '重要失效专利',
                  value: 'coreInvalidHistoryPatent',
                  path: '/core/invalid_history_patent',
                  descPath: '/opinion/core_invalid_20'
                }
              ]
            },
            {
              name: '核心专利',
              value: 'core8',
              list: [
                {
                  name: '高引用频次专利',
                  value: 'corePatent',
                  path: '/core/patent',
                  descPath: '/opinion/core_patent_10'
                }
              ]
            },
            {
              name: '法律分析',
              value: 'core9',
              list: [
                {
                  name: '转让分析',
                  value: 'coreLaw',
                  path: '/core/law',
                  descPath: [
                    '/opinion/core_law_10',
                    '/opinion/core_law_11',
                    '/opinion/core_law_13'
                  ]
                },
                {
                  name: '许可分析',
                  value: 'coreLawXk',
                  path: '/core/law_xk',
                  descPath: [
                    '/opinion/core_law_20',
                    '/opinion/core_law_21',
                    '/opinion/core_law_23'
                  ]
                },
                {
                  name: '质押分析',
                  value: 'coreLawZy',
                  path: '/core/law_zy',
                  descPath: [
                    '/opinion/core_law_30',
                    '/opinion/core_law_31',
                    '/opinion/core_law_33'
                  ]
                },
                {
                  name: '诉讼分析',
                  value: 'coreLawSs',
                  path: '/core/law_ss',
                  descPath: [
                    '/opinion/core_law_40',
                    '/opinion/core_law_41'
                  ]
                },
                {
                  name: '复审无效分析',
                  value: 'coreLawFswx',
                  path: '/core/law_fswx',
                  descPath: ['/opinion/core_law_50']
                }
              ]
            }
          ]
        },
        {
          name: '竞争对手定位',
          data: [
            {
              name: '专利概况',
              value: 'core10',
              list: [
                {
                  name: '专利申请量对比图',
                  value: 'comSummary',
                  path: '/competitor/summary',
                  descPath: '/opinion/compete_summary_10'
                },
                {
                  name: '申请趋势',
                  value: 'compTrend',
                  path: '/competitor/trend',
                  descPath: '/opinion/compete_summary_20'
                },
                {
                  name: '专利类型分布',
                  value: 'compType',
                  path: '/competitor/type',
                  descPath: '/opinion/compete_summary_30'
                },
                {
                  name: '国际布局分析',
                  value: 'compCompanyWord',
                  path: '/competitor/company_world',
                  descPath: '/opinion/compete_summary_40'
                },
                {
                  name: '发明人数分析',
                  value: 'compInventor',
                  path: '/competitor/inventor',
                  descPath: '/opinion/compete_summary_50'
                }
              ]
            },
            {
              name: '研发重点分析',
              value: 'core11',
              list: [
                {
                  name: '研发重点分析',
                  value: 'compResearch',
                  path: '/competitor/research',
                  descPath: '/opinion/compete_research_10'
                }
              ]
            },
            {
              name: '企业专利处境分析',
              value: 'core12',
              list: [
                {
                  name: '企业专利处境分析',
                  value: 'compSituationCompany',
                  path: '/competitor/situation/company',
                  descPath: '/opinion/compete_company_10'
                }
              ]
            },
            {
              name: '技术处境分析',
              value: 'core13',
              list: [
                {
                  name: '技术处境分析',
                  value: 'compCompeteSitTech',
                  path:
                      '/competitor/competitor/situation/tech',
                  descPath: '/opinion/compete_tech_10'
                }
              ]
            },
            {
              name: '企业定位分析',
              value: 'core14',
              list: [
                {
                  name: '企业定位分析',
                  value: 'compPosition',
                  path: '/competitor/position',
                  descPath: '/opinion/compete_position_10'
                },
                {
                  name: '企业关联分析',
                  value: 'compReation',
                  path: '/competitor/relation',
                  descPath: '/opinion/compete_position_20'
                }
              ]
            },
            {
              name: '引证分析',
              value: 'core15',
              list: [
                {
                  name: '引证分析',
                  value: 'compIndependence',
                  path: '/competitor/independence',
                  descPath: '/opinion/compete_yz_10'
                }
              ]
            }
          ]
        }
      ],
      tabsList: [],
      reportId: '',
      myChart: '',
      myChartList: [],
      activeKey: 0,
      option: {},
      value: '',
      activeName: '',
      descInfo: {
        desc: '',
        path: ''
      },
      dataList: [],
      dataList1: [],
      dataList2: '',
      dataList3: [],
      dataList4: [],
      activeValue: '',
      specialList: [
        'coreTech',
        'coreInventorCore',
        'coreAreaCn',
        'coreLaw',
        'coreLawXk',
        'coreLawZy',
        'coreLawSs',
        'coreLawFswx'
      ],
      descInfoList: [],
      value1: '',
      title: '',
      title1: '',
      descSaveInfo: {}
    }
  },
  components: {
    searchBar
  },
  created() {
    let value = this.$route.params.id
    this.reportId = value
    this.title = this.$route.query.title
  },
  mounted() {
    // this.initChart()
    this.$nextTick(() => {
      this.getKeyList('核心图表分析', '专利概况')
    })
  },
  computed: {
    loadingCount() {
      return this.$store.state.loadingCount
    }
  },
  watch: {
    loadingCount(val) {
      if (val > 0) {
        this.loading = true
      } else {
        this.loading = false
      }
    },
    value1(val) {
      if (val == 'coreTech') {
        this.valueList = [
          'coreTech0',
          'coreTech1',
          'coreTech2',
          'coreTech3',
          'coreTech4',
          'coreTech5'
        ]
      }
      if (val == 'coreAreaCn') {
        this.valueList = ['coreAreaCn0', 'coreAreaCn1']
      }
      if (val == 'coreInventorCore') {
        this.valueList = ['coreInventorCore0', 'coreInventorCore1']
      }
      if (val == 'coreLaw') {
        this.valueList = [
          'coreLaw0',
          'coreLaw1',
          'coreLaw2',
          'coreLaw3'
        ]
      }
      if (val == 'coreLawXk') {
        this.valueList = [
          'coreLawXk0',
          'coreLawXk1',
          'coreLawXk2',
          'coreLawXk3'
        ]
      }
      if (val == 'coreLawZy') {
        this.valueList = [
          'coreLawZy0',
          'coreLawZy1',
          'coreLawZy2',
          'coreLawZy3'
        ]
      }
      if (val == 'coreLawSs') {
        this.valueList = ['coreLawSs0', 'coreLawSs1', 'coreLawSs2']
      }
      if (val == 'coreLawFswx') {
        this.valueList = ['coreLawFswx0', 'coreLawFswx1']
      }
    }
  },
  methods: {
    ...mapActions('report', [
      'filterAnaly',
      'filterAnaly1',
      'saveFilterAnaly'
    ]),
    goEmail() {
      this.$router.push({
        path: '/report/email/' + this.reportId,
        query: {
          title: this.title
        }
      })
    },
    goDownload() {
      this.$router.push({
        path: '/report/download/' + this.reportId,
        query: {
          title: this.title
        }
      })
    },
    goBack() {
      this.$router.push({
        path: '/report',
        name: 'report'
      })
    },
    goDetail() {
      this.$router.push({
        path: '/report/detail',
        name: 'report-detail'
      })
    },
    getKeyList(name1, name) {
      this.title1 = name1
      this.initNumber()
      this.activeName = name
      let data = []
      this.activeKey = 0
      this.totalFilter.forEach(item => {
        if (item.name == name1) {
          data = item.data
        }
      })
      data.forEach(item => {
        if (item.name == name) {
          this.activeValue = item.value
          this.tabsList = item.list
          let path = item.list[0].path
          let descPath = item.list[0].descPath
          this.value = item.list[0].value
          this.watchValue()
          this.getAnalyse(path)
          this.getDescInfo(descPath)
        }
      })
    },
    initChart() {
      if (this.specialList.indexOf(this.value) > -1) {
        let dom = []
        this.valueList.forEach((item, index) => {
          let doms = document
              .getElementsByClassName('v-window-item--active')[0]
              .getElementsByClassName(item)[0]
          console.log('doms', doms)
          dom[index] = doms
          dom[index].style.height = '320px'
          this.myChartList[index] = echarts.init(dom[index])
          console.log(
              'this.myChartList[index]',
              this.myChartList[index]
          )
        })
      } else {
        let dom = document.getElementsByClassName(this.value)[0]
        console.log(
            'dom-element',
            document.getElementsByClassName(this.value)
        )
        dom.style.height = '320px'
        console.log('dom', dom)
        this.myChart = echarts.init(dom)
      }
      window.addEventListener('resize', () => {
        if (this.myChart) {
          this.myChart.resize()
        }
        if (this.myChartList.length > 0) {
          this.myChartList.forEach((item, index) => {
            this.myChartList[index].resize()
          })
        }
      })
    },

    //编辑的弹窗
    onedit() {
    },
    watchValue() {
      if (this.value == 'coreTech') {
        this.valueList = [
          'coreTech0',
          'coreTech1',
          'coreTech2',
          'coreTech3',
          'coreTech4',
          'coreTech5'
        ]
      }
      if (this.value == 'coreAreaCn') {
        this.valueList = ['coreAreaCn0', 'coreAreaCn1']
      }
      if (this.value == 'coreInventorCore') {
        this.valueList = ['coreInventorCore0', 'coreInventorCore1']
      }
      if (this.value == 'coreLaw') {
        this.valueList = [
          'coreLaw0',
          'coreLaw1',
          'coreLaw2',
          'coreLaw3'
        ]
      }
      if (this.value == 'coreLawXk') {
        this.valueList = [
          'coreLawXk0',
          'coreLawXk1',
          'coreLawXk2',
          'coreLawXk3'
        ]
      }
      if (this.value == 'coreLawZy') {
        this.valueList = [
          'coreLawZy0',
          'coreLawZy1',
          'coreLawZy2',
          'coreLawZy3'
        ]
      }
      if (this.value == 'coreLawSs') {
        this.valueList = ['coreLawSs0', 'coreLawSs1', 'coreLawSs2']
      }
      if (this.value == 'coreLawFswx') {
        this.valueList = ['coreLawFswx0', 'coreLawFswx1']
      }
    },
    handleChange(e) {
      this.activeKey = e
      this.value = this.tabsList[e].value
      this.watchValue()
      this.initNumber()
      this.$nextTick(() => {
        this.tabChange(this.tabsList[e])
      })
    },
    tabChange(item) {
      if (this.option[this.value]) {
        this.showChartDom()
        console.log('this.option', this.option)
      } else {
        // this.value = item.value
        let path = item.path
        let descPath = item.descPath
        this.getAnalyse(path)
        this.getDescInfo(descPath)
      }
    },
    showChartDom() {
      console.log('value---', this.value)
      let desc = this.descSaveInfo[this.value]
      this.descInfo = desc
      if (this.myChart) {
        this.myChart.dispose()
      }
      if (this.myChartList.length > 0) {
        this.myChartList.forEach((item, index) => {
          this.myChartList[index].dispose()
        })
      }
      let options = this.option[this.value]
      if (this.value == 'coreInvalidHistoryPatent') {
        this.dataList = options[0]
      } else if (this.value == 'corePatent') {
        this.dataList = options[0]
      } else if (this.value == 'compIndependence') {
        this.dataList1 = options[0]
      } else if (this.value == 'compReation') {
        this.dataList2 = {
          titleKey: options[0],
          valueMap: options[1]
        }
      } else if (this.value == 'coreApplicantIpcCited') {
        this.dataList3 = options[0]
      } else {
        if (this.value == 'coreTech') {
          this.dataList4 = options[6]
        }
        setTimeout(() => {
          this.initChart()
          if (this.specialList.indexOf(this.value) > -1) {
            this.descInfo = ''
            this.descInfoList = desc
            this.valueList.forEach((item, index) => {
              this.myChartList[index].setOption(options[index])
            })
          } else {
            this.myChart.setOption(options[0])
          }
        }, 1000)
      }
    },
    initNumber() {
      this.dataList = []
      this.dataList1 = []
      this.dataList2 = ''
      this.dataList3 = []
      this.dataList4 = []
      this.descInfoList = []
      this.descInfo = {}
      this.myChartList = []
      this.myChart = ''
    },
    getAnalyse(path) {
      // this.loading = true
      if (this.myChart) {
        this.myChart.clear()
      }
      if (this.myChartList.length > 0) {
        this.myChartList.forEach((item, index) => {
          this.myChartList[index].clear()
        })
      }
      let _this = this
      let data = {
        url: this.reportId + path,
        data1: {
          params: {}
        }
      }
      this.filterAnaly({
        data: data,
        handle(res) {
          console.log(res, '===============res=========')
          //以上是专利趋势的图形数据
          let option = {}
          let options = []
          if (res.success && res.success == false) {
            _this.$message({
              type: 'error',
              message: '获取失败'
            })
            _this.loading = false
          } else {
            let list = _this.getResFilter(res)
            // console.log('list----', list)
            list.forEach(item => {
              option = item
              if (option.chartType == 'pie') {
                option.series[0].radius = ['40', '90']
              }
              if (option.colors) {
                option.color = [
                  '#0095ff',
                  '#3fafff',
                  '#7fcaff',
                  '#ff6836',
                  '#ff895d',
                  '#ffb217',
                  '#ffcf6d',
                  '#ffe2a8'
                ]
              } else {
                option.color = [
                  '#0095ff',
                  '#3fafff',
                  '#7fcaff',
                  '#ff6836',
                  '#ff895d',
                  '#ffb217',
                  '#ffcf6d',
                  '#ffe2a8'
                ]
              }
              option.title ? delete option.title : ''
              option.hasData ? delete option.hasData : ''
              option.chartType ? delete option.chartType : ''
              option.colors ? delete option.colors : ''
              if (option.legendData) {
                delete option.legendData
              }
              options.push(option)
            })
            // console.log('dddd----option', options)
          }
          _this.option[_this.value] = options
          if (_this.value == 'coreInvalidHistoryPatent') {
            _this.dataList = options[0]
          } else if (_this.value == 'corePatent') {
            _this.dataList = options[0]
          } else if (_this.value == 'compIndependence') {
            _this.dataList1 = options[0]
          } else if (_this.value == 'compReation') {
            options[1].color ? delete options[1].color : ''
            _this.dataList2 = {
              titleKey: options[0],
              valueMap: options[1]
            }
          } else if (_this.value == 'coreApplicantIpcCited') {
            _this.dataList3 = options[0]
          } else {
            console.log('options[0]', options[0])
            if (_this.value == 'coreTech') {
              _this.dataList4 = options[6]
            }
            _this.initChart()
            if (_this.specialList.indexOf(_this.value) > -1) {
              options.forEach((item, index) => {
                _this.myChartList[index].setOption(item)
              })
            } else {
              _this.myChart.setOption(options[0])
              // _this.loading = false
            }
          }
        }
      })
    },
    getDescInfo(path) {
      if (this.specialList.indexOf(this.value) > -1) {
        let list = []
        path.forEach((item, index) => {
          let data = {
            url: this.reportId + item,
            data1: {}
          }
          let _this = this
          let temp = {}
          temp.path = item
          _this.filterAnaly({
            data: data,
            handle(res) {
              temp.desc = res.data.result
              console.log(res.data.result, '===res.data.result==')
            }
          })
          list.push(temp)
        })
        this.$nextTick(() => {
          this.descInfoList = list
        })
        this.descSaveInfo[this.value] = list
        console.log('descInfoList', this.descInfoList)
      } else {
        let data = {
          url: this.reportId + path,
          data1: {
            params: {}
          }
        }
        let _this = this
        this.filterAnaly1({
          data: data,
          handle(res) {
            _this.descInfo.desc = res.data.result
            console.log(res.data.result, '===res.data.result===')
            _this.descInfo.path = path
            console.log(path, '===path===')
          }
        })
        this.descSaveInfo[this.value] = this.descInfo
      }
    },
    getResFilter(res) {
      if (this.value == 'coreTrend') {
        return [res.typeTrend]
      }
      if (this.value == 'coreGrant') {
        let option = [res.inventPatentGrantRate, res.patentGrantRate]
        return option
      }
      if (this.value == 'coreHold') {
        return [res.keepPatent]
      }
      if (this.value == 'coreArea') {
        return [res.worldRank]
      }
      if (this.value == 'coreAreaTrend') {
        return [res.worldTrend]
      }
      if (this.value == 'coreTech') {
        return [
          res.ipcCompanyData,
          res.ipcCountryData,
          res.ipcHotChangeData,
          res.ipcRankData,
          res.ipcYearChangeData,
          res.ipcYearData,
          res.techDatas
        ]
      }
      if (this.value == 'coreTechActivity') {
        return [res.lifeCycle]
      }
      if (this.value == 'coreTechGroup') {
        return [res.ipcRD]
      }
      if (this.value == 'coreTechGrowth') {
        return [res.ipcRate]
      }
      if (this.value == 'coreInventor') {
        return [res.inventorRankData]
      }
      if (this.value == 'coreInventorCore') {
        return [res.inventorCoreData, res.inventorIpc]
      }
      if (this.value == 'coreInventorAnalysis') {
        return [res.inventRD]
      }
      if (this.value == 'coreApplicant') {
        return [res.applicantYearChange]
      }
      if (this.value == 'coreApplicantAgency') {
        return [res.patentActive]
      }
      if (this.value == 'coreApplicantCore') {
        return [res.applicantCore]
      }
      if (this.value == 'coreApplicantCompany5') {
        return [res.companyIpc]
      }
      //数据--不是图表
      if (this.value == 'coreApplicantIpcCited') {
        return [res.citedList]
      }
      if (this.value == 'coreAreaCn') {
        return [res.cityRank, res.provinceRank]
      }
      if (this.value == 'coreAssignee') {
        return [res.assigneeYearChange]
      }
      if (this.value == 'coreAssigneeCore') {
        return [res.assigneeCore]
      }
      if (this.value == 'coreInvalid') {
        return [res.invalidTrend]
      }
      //list
      if (this.value == 'coreInvalidHistoryPatent') {
        return [res.corePatentList]
      }
      //list
      if (this.value == 'corePatent') {
        return [res.corePatentList]
      }
      if (this.value == 'coreLaw') {
        return [
          res.srRankData,
          res.zrIPCRankData,
          res.zrRankData,
          res.zrTrend
        ]
      }
      if (this.value == 'coreLawXk') {
        return [
          res.bxkRankData,
          res.xkIPCRankData,
          res.xkRankData,
          res.xkTrend
        ]
      }
      if (this.value == 'coreLawZy') {
        return [
          res.zqRankData,
          res.zyIPCRankData,
          res.zyRankData,
          res.zyTrend
        ]
      }
      if (this.value == 'coreLawSs') {
        return [res.bsRankData, res.ssRankData, res.ssTrendData]
      }
      if (this.value == 'coreLawFswx') {
        return [res.fsRankData, res.wxRankData]
      }
      if (this.value == 'comSummary') {
        return [res.patentNumRank]
      }
      if (this.value == 'compTrend') {
        return [res.trend]
      }
      if (this.value == 'compType') {
        return [res.typeRank]
      }
      if (this.value == 'compCompanyWord') {
        return [res.companyWorld]
      }
      if (this.value == 'compInventor') {
        return [res.inventorRank]
      }
      if (this.value == 'compResearch') {
        return [res.companyIpc]
      }
      if (this.value == 'compSituationCompany') {
        return [res.companyRD]
      }
      if (this.value == 'compCompeteSitTech') {
        return [res.techSituation]
      }
      if (this.value == 'compPosition') {
        return [res.positionRD]
      }
      if (this.value == 'compReation') {
        return [res.titleKey, res.valueMap]
      }
      // list
      if (this.value == 'compIndependence') {
        return [res.applicantList]
      }
    },
    saveDesc(descInfo) {
      let data = {
        url: this.reportId + descInfo.path,
        data1: {
          params: {
            content: descInfo.desc
          }
        }
      }
      let _this = this
      this.saveFilterAnaly({
        data: data,
        handle(res) {
          _this.editVisible = false
          if (res.success) {
            _this.$message({
              type: 'success',
              message: '保存成功'
            })
          }
        }
      })
    }
  }
}
</script>
